module.exports = __webpack_public_path__ + "assets/apply3.505d53fa.svg";